import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { TransportOrderItemService } from './transport-order-item.service';
import { ILLEGAL_INVOCATION } from '../app/shared/util/security-util';
import { Observable } from 'rxjs';
import { createRequestOption } from '../app/shared/util/request-util';
import { ApplicationConfigService } from './application-config.service';
import { ApiProviderService } from './api-provider.service';
import { TransportItem } from 'models/transport-item.model';

export type EntityResponseType = HttpResponse<TransportItem>;
export type EntityArrayResponseType = HttpResponse<TransportItem[]>;

@Injectable({ providedIn: 'root' })
export class TransportOrderItemExtendedService extends TransportOrderItemService {
  protected override resourceUrl = API_ENDPOINTS.TRANSPORT_ORDER_ITEM;

  constructor(private apiProvider: ApiProviderService, http: HttpClient, applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  override create(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override update(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override partialUpdate(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override find(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<TransportItem[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  override delete(): Observable<HttpResponse<{}>> {
    throw ILLEGAL_INVOCATION;
  }
}
